/** Ruta pública de la imagen del crespón. */
export const CRESPON_SRC = '/entradas/images/crespon-eci.png'

/** Lado intrínseco de la imagen del crespón (px). */
export const CRESPON_INTRINSIC_SIZE = 300

/** Lado del crespón como fracción de la altura del logo. */
export const CRESPON_SIZE_RATIO = 0.55
